import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Caselet } from "../../utils/common";
interface CaseletState {
    caselet: Caselet;
}
interface CaseletPublishedStatusProps {
    caseletId: string;
    publishedStatus: boolean;
}
const initialState: CaseletState = {
    caselet: {
        id: "",
        title: "",
        createdTime: "",
        published: false,
        authorName: "",
        view: 0,
        summary: {
            background: "",
            scenario: "",
            outcome: "",
            possibleCurrentStates: [],
            desiredTransformationGoal: []
        },
        challenges: []
    }
};
export const updateCaseletPublishedStatus = ({ caseletId, publishedStatus }: CaseletPublishedStatusProps) => ({
    type: "caselet/updatePublishedStatus",
    payload: { caseletId, publishedStatus }
});
const caseletSlice = createSlice({
    name: "caselet",
    initialState,

    reducers: {
        initializeCaselet: (state, action: PayloadAction<Caselet>) => {
            "caselet/initializeCaselet";
            state.caselet = action.payload;
        },
        updatePublishedStatus: (state, action: PayloadAction<CaseletPublishedStatusProps>) => {
             "caselet/updatePublishedStatus";
            const { caseletId, publishedStatus } = action.payload;
            if (state.caselet.id === caseletId) {
                state.caselet.published = publishedStatus;
            }
        },
        updateCaselet: (state, action: PayloadAction<Caselet>) => {
            "caselet/updateCaselet";
            state.caselet = action.payload;
        },

        addDecisionPointManually: (state, action: PayloadAction<Caselet>) => {
            state.caselet = action.payload;
        }
    }
});

// Export the existing actions
export const { initializeCaselet, updateCaselet,updatePublishedStatus} = caseletSlice.actions;
// Export the new action for adding a Decision Point
export const { addDecisionPointManually } = caseletSlice.actions;

export default caseletSlice.reducer;
